'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('SuperAdmin', ['Role', function(Role) {
    return Role.newFrozenInstance('*');
}]);